<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <h3>Ports</h3>
            </div>
            <div class="col-lg-6" v-if="portMenu.length && orderedPorts.length">
                <div class="text-right">
                    <div class="sau-menu text-center">
                        <button class="dropbtn sau-font sm px-0">View History <i class="fa fa-chevron-down" aria-hidden="true"></i></button>
                        <div class="sau-menu-content dd">
                            <a href="#" @click.prevent="updatePortGraphs(item)" v-for="(item, index) in portMenu" :key="index">{{ item.text }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="gotData">
            <!-- loop ports -->
            <template v-if="orderedPorts.length">
                <div class="sau-bx bx-pad">
                    <div v-for="(port, key) in orderedPorts" :key="key" class="pb-12">
                        <div class="row">
                            <div class="col">
                                <h4>
                                    {{ port.name }} - <span class="sau-font sm">{{ port.billed ? 'Billed' : 'Not Billed' }}</span>
                                    <span class="sau-help sm ml-1 align-middle" v-b-tooltip.hover :title="createToolTip(port.billed)">?</span>

                                    <span v-if="port.device" class="sau-font sm">
                                        <br />Graph for <a :href="port.device.link">{{port.device.sau_order_id}} - {{port.device.name}}</a>
                                    </span>
                                </h4>
                            </div>
                        </div>
                        <div class="row" >
                            <div class="col">
                                <div class="sau-bx bx-pad text-center">
                                    <img class="img-fluid" :src="getPortGraph(port.details.id)" alt="Port Graph" />
                                    <p class="pt-4"> {{ selectedTimeRange.text }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>

                <sau-apiro-response type="message" support="true">
                    <template slot="message">No port graphs available.</template>
                    <template slot="details">
                        <p>We can't retrieve your bandwidth data at the moment. However support can quickly attend to this.</p>
                    </template>
                </sau-apiro-response>

            </template>
        </template>
        <div v-else>
            <sau-loading>
                <template slot="message">Fetching Port Graphs</template>
            </sau-loading>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ports: [],
            portMenu: [
                {val: 'lasthour', text: 'Last Hour'},
                {val: 'currentday', text: 'Current Day'},
                {val: 'previousday', text: 'Previous Day'},
                {val: 'lastday', text: 'Last Day'},
                {val: 'last30days', text: 'Last 30 Days'},
                {val: 'currentmonth', text: 'Current Month'},
                {val: 'previousmonth', text: 'Previous Month'},
                {val: 'currentyear', text: 'Current Year'},
                {val: 'previousyear', text: 'Previous Year'},
            ],
            selectedTimeRange: {val: 'currentmonth', text: 'Current Month'},
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getCurrentPortData().then(response => {
                if(response.data.status = 'success') {
                    this.ports = response.data.ports;
                    if (Object.values(this.ports).filter((port) => port.billed).length === 0) {
                        this.$emit('no-billed-ports')
                    }
                }
            })
        },
        getPortGraph(id) {
            return '/service/' + this.getServiceType() + '/' + this.getServiceId() + '/port/' + id + '/graphs/' + this.selectedTimeRange.val;
        },
        updatePortGraphs(range) {
            /** Set all graphs to the 'selected.text' value */
            this.selectedTimeRange = range;
        },
        createToolTip(billed) {
            return billed ? 'All data transfer (In and Out) on this network port will count towards your monthly quota' : 'Data transfer on this network port does not count towards your monthly quota';
        },
    },
    computed: {
        orderedPorts() {
            // Sort the ports by billed in descending order, then sort to put null values at the end
            return this.ports ? (_.orderBy(this.ports, 'billed', 'desc').sort((a, b) => (a.billed===null)-(b.billed===null) || -(a.billed > b.billed) || +(a.billed < b.billed) )) : [];
        }
    }
}
</script>
<style>
</style>
